import React, { useState } from 'react';
import SpecialOfferBanner from '../components/SpecialOfferBanner';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import PrepaidServicesSection from '../components/PrepaidServicesSection';
import ProductsSection from '../components/ProductsSection';
import WhyChooseSection from '../components/WhyChooseSection';
import BeforeAfterSection from '../components/BeforeAfterSection';
import ReviewsSection from '../components/ReviewsSection';
import FAQSection from '../components/FAQSection';
import ContactSection from '../components/ContactSection';
import AreasWeServeSection from '../components/AreasWeServeSection';
import TrustBadgesSection from '../components/TrustBadgesSection';
import Footer from '../components/Footer';
import QuoteModal from '../components/QuoteModal';
import ScrollToTopButton from '../components/ScrollToTopButton';
import WhatsAppButton from '../components/WhatsAppButton';
import StickyMobileCTA from '../components/StickyMobileCTA';

const HomePage = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <div className="min-h-screen has-sticky-mcta">
      <SpecialOfferBanner onGetQuote={() => setIsQuoteModalOpen(true)} />
      <HeroSection onGetQuote={() => setIsQuoteModalOpen(true)} />
      <ServicesSection />
      <WhyChooseSection />
      <ProductsSection />
      <PrepaidServicesSection />
      <ReviewsSection />
      <FAQSection />
      <AreasWeServeSection />
      <ContactSection />
      <TrustBadgesSection />
      <Footer />
      <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
      />
      <ScrollToTopButton />
      <WhatsAppButton />
      <StickyMobileCTA onGetQuote={() => setIsQuoteModalOpen(true)} />
    </div>
  );
};

export default HomePage;
